import styled from 'styled-components'

function WhyHKC() {
  return (
   <Wrapper>
    <section className='why'>
    <h3>Why Holy Krishna's College, Dineshpur?</h3>
    <p className='details'>Throughout the academic session, a range of essential skills and values are instilled in students, both overtly and subtly, as an integral part of their learning journey</p>

    <div className='box_container'>
        <div className="box1">
            <h4>Career Skills</h4>
            <p className='para2'>
                <ul>
                    <li>Student Leadership</li>
                    <li>Personality Development</li>
                    <li>Digital Fluency</li>
                    <li>Innovative Thinking</li>
                    <li>Verbal & Nonverbal Communication</li>
                </ul>
            </p> 
        </div>
        <div className='box2'>
            <h4>Practical Skills</h4>
            <p className='para2'>
               
                    <ul>
                        <li>Mental Health Management</li>
                        <li>Anxiety Reduction</li>
                        <li>Analytical Skills</li>
                        <li>Intuitive Reasoning</li>
                        <li>Social Awareness</li>
                    </ul>
               
            </p> 
        </div>
    </div>
    </section>
   </Wrapper>
  )
}
const Wrapper = styled.section`
  .why{
    background-color:#f8f9fa;
    padding: 4rem 0;
  }
  h3{
    text-align:center;
    font-size:4rem;
    font-weight:500;
    margin-bottom: 2rem;
  }
  h4{
    text-align:left;
    font-size:2.8rem;
    font-weight:500;
    margin-top:1.5rem;
    margin-left:10px;
  }
  ul li{
    list-style-type:disc;
  }
  .details{
    text-align:center;
    font-size:1.8rem;
    font-weight:500;
    margin-bottom: 4rem;
    line-height:2rem;
  }
  .box1, .box2{ 
    p{
      font-size: 2rem;
      line-height: 1.2;
      padding-bottom:5px;
      margin:0 10px;
    }
  }
  span{
    color:red;
  }
  img{
    width:100%;
    transition: all 250ms ease-in;
    &:hover{
      transform: scale(1.05);
      opacity: 0.8;
    }
  }
  .box_container{
    display: flex;
    justify-content: space-evenly;
  }

  @media (max-width: 768px) {
    .why{
      padding: 2rem;
    }
    h3{
      font-size: 3rem;
    }
    .box_container{
      flex-direction: column;
    }
    .box1, .box2{
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 768px) {
    h3{
      font-size: 4.5rem;
    }
    .details{
      font-size: 2.5rem;
      line-height:18px;
    }
    .box1, .box2{ 
    margin-left:30%;
      p{
        font-size: 2.5rem;
        
      }
    }
  }
`;
export default WhyHKC